import * as React from "react";

export const Details = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.45236 3.60002C6.78373 3.60002 7.05236 3.3314 7.05236 3.00002C7.05236 2.66865 6.78373 2.40002 6.45236 2.40002H2.99998C2.6686 2.40002 2.39998 2.66865 2.39998 3.00002V6.4524C2.39998 6.78378 2.6686 7.0524 2.99998 7.0524C3.33135 7.0524 3.59998 6.78378 3.59998 6.4524V4.44855L11.5514 12.4H9.5476C9.21622 12.4 8.9476 12.6687 8.9476 13C8.9476 13.3314 9.21622 13.6 9.5476 13.6H13C13.3313 13.6 13.6 13.3314 13.6 13V9.54764C13.6 9.21627 13.3313 8.94764 13 8.94764C12.6686 8.94764 12.4 9.21627 12.4 9.54764V11.5515L4.4485 3.60002H6.45236Z"
    />
);
